import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';
import {DispatchMethod} from 'hooks/Job/Job';
import {Job} from 'shared/types/PartialJob';

interface SubmitJobButtonTextProps {
    job: Partial<Job>;
    jobConfirmationEnabled?: boolean;
    noVariations: boolean;
    extraVariation: boolean;
    paymentGatewaysEnabled?: boolean;
    confirmationPage?: boolean;
    overPaid?: boolean;
}

export const submitJobButtonText = ({
    job,
    jobConfirmationEnabled = false,
    noVariations,
    extraVariation,
    paymentGatewaysEnabled = false,
    confirmationPage = false,
    overPaid = false,
}: SubmitJobButtonTextProps) => {
    let buttonText = 'Submit Job';
    const hasFreight = job?.dispatchMethod != DispatchMethod.PICKUP;

    if (
        jobConfirmationEnabled &&
        paymentGatewaysEnabled &&
        noVariations &&
        !hasFreight
    ) {
        buttonText = 'Checkout';
    }

    if (job?.status === JOB_STATUS.JOB_PENDING_CONFIRMATION) {
        if (!noVariations && !extraVariation && job?.freightCost == 0) {
            buttonText = 'Confirm Variation Cost';
        } else if (noVariations && !extraVariation && job?.freightCost == 0) {
            buttonText = 'Approve without Variations';
        } else {
            buttonText = 'Approve Job';
        }

        if (paymentGatewaysEnabled) {
            buttonText = 'Checkout';
        }

        if (
            paymentGatewaysEnabled &&
            (!noVariations || extraVariation || hasFreight)
        ) {
            buttonText = 'Confirm Variations and Checkout';
        }

        if (overPaid) {
            buttonText = 'Approve Job';
        }
    }

    // only use this if job is in processing
    if (
        jobConfirmationEnabled &&
        job?.status == JOB_STATUS.PROCESSING &&
        !confirmationPage
    ) {
        buttonText = 'Confirm Order Details';
    }

    return buttonText;
};
